<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%;background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);
    z-index: 1000; color: white;" title="绑定银行卡" left-arrow @click-left="$router.back()" />
    <div style="height: 46px "></div>

    <!-- 真实姓名 -->
    <div class="usrse">
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">真实姓名</div>
        <div style="flex: 1; margin-left: 10px;">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_owner" placeholder="请输入真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="font-size: 0.30rem; color: #3d72fa; text-align: center; box-sizing: border-box; padding: 6px">
      为了您的资金能够迅速到账，请确保填写的姓名与银行卡开户姓名一致
    </div>

    <div class="usrse">
      <!-- 选择银行 -->
      <div class="hgs" @click="changShow" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">选择银行</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank" placeholder="请选择银行" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 银行卡号 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">银行卡号</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_no" placeholder="请输入银行卡号" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 开户名称 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">开户名称</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="cardInfo.bank_address" placeholder="请输入开户名称" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 确认姓名 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">确认姓名</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <div class="van-cell-group van-hairline--top-bottom">
            <div class="van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body"><input type="text" readonly onfocus="this.removeAttribute('readonly');" auto-complete="off" onblur="this.setAttribute('readonly',true);" v-model="confirmName" placeholder="请再次输入真实姓名" class="van-field__control" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支付密码 -->
      <div class="hgs" style="display: flex; align-items: center; justify-content: space-between;">
        <div class="nams">支付密码</div>
        <div style="flex: 1; margin-left: 10px; border-bottom: 1px solid #f2f2f2">
          <van-cell-group>
            <van-field v-model="cardInfo.pay_pass" type="password" placeholder="请输入支付密码" />
          </van-cell-group>
        </div>
      </div>

      <van-button type="info" style="margin-top: 20px; width: 100%" @click="bindCard">确认添加</van-button>
      <div style="height: 60px"></div>
    </div>

    <!-- 选择银行弹层 -->
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="选择银行" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'addBankCardOnly',
  data() {
    return {
      cardInfo: {
        type: 3,             // 3=银行卡
        bank_owner: '',      // 真实姓名
        bank: '',            // 选择的银行
        bank_no: '',         // 银行卡号
        bank_address: '',    // 开户名称
        pay_pass: '',        // 支付密码
      },
      confirmName: '',       // 确认姓名（仅前端校验，必须和 bank_owner 一致）
      banklist: [],
      show: false,
    };
  },
  created() {
    let that = this;
    that.getBanklist();
  },
  methods: {
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.cardInfo.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
      .post('/api/banklist', { type: 3 })   // ← 加 type: 3
      .then(res => {
      if (res.code == 200) {
        that.banklist = res.data;
      }
      that.$parent.hideLoading();
    })
    .catch(res => {
      that.$parent.hideLoading();
    });
    },
    bindCard() {
      let that = this;
      if (!that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '请输入真实姓名');
        return;
      }
      if (!that.cardInfo.bank) {
        that.$parent.showTost(0, '请选择银行');
        return;
      }
      if (!that.cardInfo.bank_no) {
        that.$parent.showTost(0, '请输入银行卡号');
        return;
      }
      if (!that.cardInfo.bank_address) {
        that.$parent.showTost(0, '请输入开户名称');
        return;
      }
      if (!that.confirmName) {
        that.$parent.showTost(0, '请输入确认姓名');
        return;
      }
      // 关键校验：确认姓名必须和真实姓名一致
      if (that.confirmName !== that.cardInfo.bank_owner) {
        that.$parent.showTost(0, '确认姓名与真实姓名不一致');
        return;
      }
      if (!that.cardInfo.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      if (that.cardInfo.bank_no.length < 8) {
        that.$parent.showTost(0, '请输入正确的银行卡号');
        return;
      }
      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '支付密码长度为6-18位');
        return;
      }
      that.$parent.showLoading();
      // confirmName 不提交，仅前端校验
      that.$apiFun
        .post('/api/bindcard', that.cardInfo)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '绑定成功');
            that.$router.back();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {},
  updated() {},
};
</script>

<style lang="scss" scoped>
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
  }
  .hgs {
    margin-top: 10px;
    margin-bottom: 15px;
    padding: 8px 0;
  }
  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;
    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }
    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}
</style>
<style>
/* 全局样式，确保导航栏标题和返回箭头为白色 */
.van-nav-bar__title {
  color: white !important;
}
.van-icon-arrow-left {
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/addBankCardOnly.vue